exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  min-height: 100%;\n  background: transparent;\n}\n\nbody {\n  background: #e8e8eb center no-repeat;\n  background-image: -webkit-gradient(linear, left top, right top, from(#f4f4f5), to(#dcdbe0));\n  background-image: linear-gradient(to right, #f4f4f5, #dcdbe0);\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\nh1 {\n  color: #9a94b2;\n  font-size: 28px;\n  margin-bottom: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/styles/index.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/styles/index.css
// module chunks = 0